module.exports = __webpack_public_path__ + "img/bg_redeem.0536e023.png";